// PermissionGate.js
import React from "react";
import { useAuth } from "../context/AuthContext";

const PermissionGate = ({ requiredPermission, fallback = null, grayOutIfUnauthorized = false, children }) => {
  const { permissions } = useAuth();
  const allowed = permissions && permissions[requiredPermission];

  if (allowed) {
    // User has permission; render children normally.
    return <>{children}</>;
  }

  if (grayOutIfUnauthorized) {
    // Render the children grayed out and inactive.
    return <div style={{ opacity: 0.5, pointerEvents: "none" }}>{children}</div>;
  }

  // If no permission and not graying out, render fallback (default is null).
  return fallback;
};

export default PermissionGate;
